import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { FlatList, Platform, Pressable, View, } from 'react-native';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import Divider from '../divider/Divider';
import { getParameters } from '../pages/utils';
const ListBase = ({ data, onPress, action, triggerAction, selectedMap = {}, hideCheck = false, }) => {
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        let params = getParameters(window?.location?.href);
        isDarkMode = params.isDarkMode;
    }
    const handleAction = (index) => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: index,
                    selectedMap: selectedMap,
                },
            });
    };
    const handleEditAction = (action, index) => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: index,
                    selectedMap: selectedMap,
                },
            });
    };
    const renderItem = ({ item, index }) => {
        return (React.createElement(View, { nativeID: 'txt_setCreditLimit' + (index + 1), style: {
                flexDirection: 'row',
                flex: 1,
                paddingVertical: 16,
            } },
            React.createElement(View, { style: {
                    flex: 1,
                    flexDirection: 'column',
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        flex: 1,
                        width: '80%',
                    } },
                    !hideCheck ? (React.createElement(React.Fragment, null,
                        React.createElement(Pressable, { nativeID: 'cb_setCreditLimit_check' + (index + 1), onPress: () => {
                                selectedMap[index] =
                                    !selectedMap[index];
                                data[index].trailIcon.name =
                                    selectedMap[index]
                                        ? IconTokens.CheckedSquare
                                        : IconTokens.NotCheckedSquare;
                                handleAction(index);
                            }, style: { paddingRight: 12 } },
                            React.createElement(View, { style: { paddingLeft: 2, paddingTop: 2, paddingBottom: 2 } },
                                React.createElement(Icon, { name: selectedMap[index]
                                        ? IconTokens.CheckedSquare
                                        : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL }))))) : (React.createElement(React.Fragment, null)),
                    React.createElement(View, { style: {
                            flex: 1,
                            flexDirection: 'column',
                        } },
                        React.createElement(Typography, { label: item['label'], numberOfLines: 3, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, lineHeight: 20 }),
                        item && item.secondaryText ? (React.createElement(View, { style: { marginTop: 8 } },
                            React.createElement(Typography, { label: item.secondaryText, numberOfLines: 3, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, lineHeight: 18 }))) : (React.createElement(React.Fragment, null))))),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                } },
                React.createElement(View, { style: {
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                    } },
                    React.createElement(Typography, { label: item['trailTitle'], fontFamily: FontFamilyTokens.Inter, fontWeight: '500', fontSize: FontSizeTokens.SM, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, lineHeight: 20 }),
                    React.createElement(Typography, { label: item['trailSubTitle'], fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, lineHeight: 18 })),
                React.createElement(View, { style: { marginTop: 2, marginLeft: 8 } }, item['trailIcon'] ? (item['trailIconAction'] ? (React.createElement(React.Fragment, null,
                    React.createElement(Pressable, { nativeID: 'bt_setCreditLimit_edit' + (index + 1), onPress: () => handleEditAction(item['trailIconAction'], index), style: {
                            marginTop: 6
                        } },
                        React.createElement(View, { style: { padding: 2, paddingLeft: 6 } },
                            React.createElement(Icon, { name: IconTokens.Edit, size: IconSizeTokens.XXL, color: ColorTokens.White }))))) : (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Icon, { name: IconTokens.Edit, size: IconSizeTokens.XXL, color: ColorTokens.White })))) : (React.createElement(React.Fragment, null))))));
    };
    const separator = () => {
        return (React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 }));
    };
    const handleEmpty = () => {
        return (React.createElement(Typography, { label: 'No Data Found !', fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.White }));
    };
    return (React.createElement(FlatList, { data: data, renderItem: renderItem, showsVerticalScrollIndicator: false, ItemSeparatorComponent: separator, ListEmptyComponent: handleEmpty, keyExtractor: (index) => index.toString(), extraData: {
            ...Object.values(data),
            ...Object.values(selectedMap),
        } }));
};
export default memo(ListBase);
export { ListBase };
